import { setApprovalPersonListSelected } from 'actions/approvalPersonActions.js';
import { getFullName } from 'helpers/fieldsHelpers';
import { APPROVAL_PERSON_SIDEBAR } from 'constants/sidebarTypes';

import { ApprovalSidebarLink, TextLine, SentDate, createCheckboxCell } from 'components/common/tableComponents/cellTemplates';

const ApprovalPersonTableTemplates = {
    checkbox:   createCheckboxCell('approvalPerson', setApprovalPersonListSelected),
    general:    ApprovalSidebarLink(APPROVAL_PERSON_SIDEBAR, 'projectName', getFullName),
    date:       SentDate,
};

export default function getApprovalPersonTableTemplate(columnName) {
    return ApprovalPersonTableTemplates[columnName] || TextLine;
}
